/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri May 09 2025
 **/

import { ZIndex } from "@/frameworks/core/commons";

export default function SidebarOverlay() {
	return (
		<div
			className="dimmed"
			css={{
				position: "absolute",
				width: "100%",
				height: "100%",
				backgroundColor: "rgba(0, 0, 0, 0.4)",
				zIndex: ZIndex.SIDEBAR + 1
			}}
		/>
	);
}
